import React, { ReactNode, createContext, useState } from "react";

interface ReloginContextValue {
  relogin?: () => Promise<void>;
  setRelogin: React.Dispatch<
    React.SetStateAction<(() => Promise<void>) | undefined>
  >;
}

const ReloginContext = createContext<ReloginContextValue | undefined>(
  undefined
);

const ReloginProvider = ({ children }: { children: ReactNode }) => {
  const [relogin, setRelogin] = useState<(() => Promise<void>) | undefined>(
    undefined
  );

  return (
    <ReloginContext.Provider value={{ relogin, setRelogin }}>
      {children}
    </ReloginContext.Provider>
  );
};

export { ReloginContext, ReloginProvider };
